import React, { useState } from 'react';

export default function PageMining() {
  const [config, setConfig] = useState({
    threads: 4,
    proxy: true,
    depth: 1000
  });

  const startMining = () => {
    console.log("Lancement du minage avec config:", config);
    // Ici tu feras ton appel API vers ton backend Python
    // fetch('http://localhost:5000/start', { method: 'POST', body: JSON.stringify(config) })
  };

  return (
    <div className="h-full w-full p-8 flex flex-col items-center justify-center bg-[#0a0a0c]">
      <div className="w-full max-w-md bg-[#111114] border border-gray-800 rounded-2xl p-8 shadow-2xl">
        <div className="mb-8">
          <h2 className="text-2xl font-black tracking-tighter text-white">CONFIGURATION</h2>
          <p className="text-gray-500 text-xs uppercase tracking-[0.2em]">Paramètres de session</p>
        </div>

        <div className="space-y-6">
          {/* Input Threads */}
          <div>
            <label className="block text-[10px] font-black text-gray-500 uppercase mb-2">Puissance (Threads)</label>
            <input 
              type="number" 
              value={config.threads}
              onChange={(e) => setConfig({...config, threads: e.target.value})}
              className="w-full bg-[#0a0a0c] border border-gray-800 rounded-lg p-3 text-blue-500 font-mono outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          {/* Toggle Proxy */}
          <div className="flex items-center justify-between p-4 bg-[#0a0a0c] border border-gray-800 rounded-lg">
            <span className="text-[10px] font-black text-gray-500 uppercase">Rotation Proxy</span>
            <button 
              onClick={() => setConfig({...config, proxy: !config.proxy})}
              className={`w-12 h-6 rounded-full transition-colors relative ${config.proxy ? 'bg-blue-600' : 'bg-gray-700'}`}
            >
              <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-all ${config.proxy ? 'left-7' : 'left-1'}`} />
            </button>
          </div>

          {/* Start Button */}
          <button 
            onClick={startMining}
            className="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white font-black rounded-xl transition-all active:scale-[0.98] shadow-xl shadow-blue-900/20 flex items-center justify-center gap-3"
          >
            <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
            LANCER L'EXTRACTION
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-800/50">
          <p className="text-[9px] text-gray-600 text-center leading-relaxed">
            SYSTEM STATUS: READY<br/>
            DATABASE CONNECTED: SQLITE_V3
          </p>
        </div>
      </div>
    </div>
  );
}